import { AppTheme, AppStyles } from '../styles/AppTheme';
import { css, StyleSheet } from 'aphrodite';

const BORDER_RADIUS = 15
const WIDTH = '80%'
const mainTitleSize = '22px'

export const CommonTheme = {
  productDetailsFontSize: 14,
  white: '#ffffff',
  black: 'black',
  textColor: '#004d5d',
  webViewPort: '70%',
  mobViewPort: '90%',
  borderRadius: 10,
  color1:'#0C4D5D',
  color2: '#00b2c8',
}
export const CommonStyles = StyleSheet.create({
  textfulPageContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    margin: 20,
    width: CommonTheme.webViewPort,
    maxWidth: AppTheme.viewPort,
    paddingBottom: 100,
    '@media (max-width: 767px)': {
      width:  '90%',
    }
  },
  textfulPageSubtitle: {
    fontSize: 16,
    color: CommonTheme.textColor,
  },
  textfulPageTitle: {
    color: AppTheme.primaryColor,
  },
  textfulPagePara: {
    fontSize: 12,
    marginTop: 0,
  },
  logoImage: {
    height: 40
  },
  linkTextColor: {
    color: 'black'
  },
  listItemText: {
    margin: 0,
    fontSize: 10,
    color: 'lightgrey',
    wordBreak:'break-word',
    '@media (max-width: 767px)': {
      fontSize: 12,
    }
  },
  listItemTitle: {
    margin: 0,
    fontSize: 14,
    color: CommonTheme.textColor,
    fontWeight: 'bolder',
    wordBreak:'break-word',
    height: 37,
    overflow: 'hidden',
    ':hover': {
      color: AppTheme.primaryColor
    },
  },
  pageTitle: {
    color: 'black',
    fontSize: '20px',
    fontWeight: 'bolder',
  },
  progress: {
    color: AppTheme.primaryColor,
    alignSelf:'center',
  },
  similiarProductTitle: {
    color: CommonTheme.textColor,
    fontSize: '20px',
    fontWeight: 'bolder',
    margin: '0px 0px 20px 0px',
  },
  similiarProductsSubContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: AppTheme.pagePadding * 2,
    '@media(max-width: 767px)': {
      alignItems: 'center',
      justifyContent: 'center'
    },
  },
  link: {
    textDecoration: 'none'
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: CommonTheme.white,
    width: CommonTheme.webViewPort,
    marginBottom: '30px',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      width: '100%',
      marginTop: 20,
    },
    '@media (min-width: 768px) and (max-width: 1024px)': {
      width: CommonTheme.mobViewPort,
    },
  },
  leftContainer: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      width: '100%',
      alignItems: 'center'
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      width: '35%',
    },
  },
  rightContainer: {
    width: CommonTheme.webViewPort,
    display: 'flex',
    flexDirection: 'column',
    marginTop: '30px',
    '@media (max-width: 767px)': {
      width: CommonTheme.mobViewPort,
      alignSelf: 'center',
      marginTop: '15px',
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      width: '65%',
    },
  },
  subContainer: {
    backgroundColor: CommonTheme.white,
    borderRadius: BORDER_RADIUS,
    width: WIDTH,  //TODO
    margin: '30px 0px 0px 0px',
    overflow: 'hidden',
    boxShadow: '2px 2px 15px  rgba(19, 19, 19, 0.2)',//TODO Need?
    '@media (max-width: 767px)': {
      width: CommonTheme.mobViewPort,
      margin: '15px 0px 0px 0px',
    },
  },
  knowMoreTile: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundColor: CommonTheme.white,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    minHeight: 150, // TODO
    width: '100%',// TODO,
    justifyContent: 'center',
    fontSize: '16px',
    '@media (max-width: 767px)': {
      width: '100%',
      minHeight: 'auto',
      paddingTop: 20,
      paddingBottom: 20,
    },
  },
  knowMoreIcon: {
    color: CommonTheme.white,
    fontSize: 20,
    marginLeft: AppTheme.pagePadding / 2
  },
  knowMoresubContainer: {
    width: CommonTheme.webViewPort,
    alignSelf: 'center',
    padding: '5px 0px'
  },
  knowMoreTileText: {
    display: 'flex',
    color: CommonTheme.white,
    whiteSpace: 'pre-line',
    alignItems: 'center',
    margin: 0,
    '@media (max-width: 767px)': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }
  },
  knowMoreSubTileText: {
    fontSize: '14px',
    marginTop: AppTheme.pagePadding * 2,
  },
  knowMoreTileTextSpec: {
    marginTop: AppTheme.pagePadding * 2,
    fontSize: '14px',
    ':hover': {
      cursor: 'pointer'
    }
  },
  knowMoreTileButton: {
    border: '1px solid transparent',
    fontSize: '14px',
  },
  productsSlider: {
    display: 'flex',
    padding: '20px 0px 20px 0px',
    backgroundColor: CommonTheme.color1,
    borderRadius: CommonTheme.borderRadius,
    flexDirection: 'column',
    minHeight: '315px',
    justifyContent: 'center'
  },
  descrText: {
    color: CommonTheme.white,
    fontSize: '14px',
    textAlign: 'center',
    width: CommonTheme.webViewPort,
    alignSelf: 'center',
    margin: '0px 0px 10px 0',
    fontWeight: 'bold'
  },
  descrTextSpec: {
    color: CommonTheme.black,
    width: CommonTheme.mobViewPort,
  },
  equipmentSlider: {
    display: 'flex',
    padding: '20px 0px 20px 0px',
    backgroundColor: '#F4F4F4',
    borderRadius: CommonTheme.borderRadius,
    flexDirection: 'column',
    marginTop: 'inherit',
    border: '1px solid lightgrey',
    minHeight: '100px',
    justifyContent: 'center'
  },
  sliderTitle: {
    color: CommonTheme.textColor,
    textAlign: 'center',
    margin: '0px 0px 10px 0px',
    fontSize: mainTitleSize
  },
  sliderTitleVariant: {
    color: 'white',
    textAlign: 'center',
    margin: '0px 0px 10px 0px',
    fontSize: mainTitleSize
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: 'transparent'
  },
  relatedImageSelectionContent: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  rightArrow: {
    '@media (max-width: 767px)': {
      marginLeft: 0,
    }
  },
  findOutMoreTile: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    height: '250px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 'inherit',
    padding: '40px',
    backgroundBlendMode: 'overlay',
    '@media (max-width: 767px)': {
      padding: '20px',
    }
  },
  terms: {
    width: '100%',
    textDecoration: 'none',
  },
  findOutMoreSubTile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    width:'50%',
    '@media (max-width: 767px)': {
      width:'80%',
    }
  },
  findOutMoreTite: {
    color: CommonTheme.white,
    margin: 0
  },
  arrowIcons: {
    fontSize: 30,
    color: '#8dc73f'
  },
  arrowIconsDisabled: {
    fontSize: 30,
    color: 'transparent',
  },
  arrowIconsDisabledContainer: {
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent',
    }
  },
  findOutMoreButton: {
    color: CommonTheme.textColor,
    backgroundColor: CommonTheme.white,
    fontWeight: 'bolder',
    marginTop: AppTheme.pagePadding * 2,
  },
  videoContainer: {
    backgroundColor: AppTheme.primaryColor,
    borderRadius: BORDER_RADIUS,
    marginTop: 'inherit',
    height: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '60px' //TODO change
  },
  videoTitle: {
    color: CommonTheme.white,
    width: '80%',
    alignSelf: 'center',
    textAlign: 'center',
    margin: '30px 0px 0px 0px',
    fontSize: 18,
  },
  demoVideo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '30px',
    marginBottom: -70,
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    boxShadow: '0 2px 20px 0 rgba(0, 0, 30, 0.1), 10px 12px 24px 0 rgba(0, 0, 0, 0.17)'
  },
  overView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 'inherit'
  },
  marginTop: {
    marginTop: 20
  },
  subTitle: {
    color: CommonTheme.textColor,
    fontWeight: 'bolder',
    margin: '0px 0px 20px 0px',
    fontSize:mainTitleSize
  },
  healthCountContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
    }
  },
  healthCountSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    margin: '0px 10px',
    padding: AppTheme.pagePadding,
    flex: 1,
    '@media (max-width: 767px)': {
      margin: '5px',
      alignItems: 'center',
    }
  },
  healthCountImage: {
    width: 30,
    height: 30,
    objectFit: 'contain',
  },
  countNumber: {
    fontSize: '28px',
    color: CommonTheme.black,
    margin: '10px 0px',
  },
  countTitle: {
    fontSize: '16px',
    margin: 0,
    color: CommonTheme.black,
    fontWeight: 'bolder',
    textAlign: 'left',
    minHeight: '50px',
    '@media (max-width: 767px)': {
      minHeight: 0,
      fontSize: '14px',
    }
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 'inherit'
  },
  reasonsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  reasonsInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  partnersSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  partnersLogoContainer: {
    border: '1px solid lightgrey',
    padding: AppTheme.pagePadding * 2,
    borderRadius: CommonTheme.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '5px 5px 5px 5px',
  },
  partnersLogo: {
    width: 100,
    height: 100,
    objectFit: 'contain',
    '@media (max-width: 767px)': {
      width: 80,
      height: 80
    }
  },
  viewAllDeals: {
    color: '#4db0c5',
    alignSelf: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    margin: '20px 0px 0px 0px',
    fontSize:'18px',
    ':hover': {
      cursor: 'pointer'
    }
  },
  viewAllDealsCust: {
    color: 'white',
    fontSize: 15,
  },
  viewAllIcon: {
    color: '#4db0c5',
    fontSize: 30,
    marginLeft: AppTheme.pagePadding
  },
  viewAllIconCust: {
    color: 'white',
    fontSize: 22,
  },
  listTitle: {
    backgroundColor: '#C2D5DE',
    padding: AppTheme.pagePadding * 2,
    color: CommonTheme.white,
    margin: 0
  },
  progressBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: AppTheme.pagePadding * 2,
    minHeight: '370px',
    '@media (max-width: 767px)': {
      minHeight: 0,
    }
  },
  reasonTextContainer: {
    flex: 1,
    overflow: 'hidden',
    margin: '0px 10px',
    '@media (max-width: 767px)': {
      margin: '10px',
    },
    '@media (max-width: 1023px)': {
      marginTop: 20
    }
  },
  reasonTitle: {
    margin: '10px 0px',
    fontWeight: 'bolder',
    '@media (max-width: 1023px)': {
      marginTop: 0
    }
  },
  reasonText: {
    margin: 0
  },
  homeIcon: {
    fontSize: 50,
  },
  videoContainerTile: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: window.innerWidth < 768 ? 300 : 500,
    height: 250,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  playButton: {
    width: 80,
    height: 80,
    ':hover': {
      cursor: 'pointer'
    }
  },
  newsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  whtsAppImage: {
    display: 'flex',
    width: '28px',
    height: '28px',
    marginRight: 2.5
  },
});



// WEBPACK FOOTER //
// ./src/styles/Styles.js